var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    style: {
      height: "100%",
      width: "100%",
      background: "none",
      shapeRendering: "auto"
    },
    width: "294px",
    height: "294px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px",
      transform: "rotate(0deg)",
      animation: "2s linear 0s infinite reverse forwards running spin-b48b75b7-efa1-4baa-8473-555f7a3961d9"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e15c64",
    d: "M10.1 46.6c.9-8.7 4.4-17.2 10.4-23.6 3-3.2 6.4-5.9 10.2-8.1 3.8-2.1 8-3.5 12.3-4.3 8.6-1.6 17.7-.1 25.4 3.9 3.9 2 7.4 4.7 10.4 7.8 3 3.2 5.5 6.8 7.4 10.7-2.4-3.7-5.3-7-8.6-9.6-3.3-2.6-6.9-4.7-10.7-6-3.8-1.3-7.7-2-11.6-2.1-1 0-1.9 0-2.9.1l-2.8.3c-1.9.4-3.7.7-5.4 1.4-3.5 1.2-6.7 2.9-9.5 5-2.8 2.2-5.1 4.7-6.9 7.5-1.8 2.8-3.1 5.8-3.8 8.8-.7 3.1-.9 6.1-.7 9.1.3 3.7-2.5 6.9-6.1 7.2-3.7.3-6.9-2.5-7.2-6.1v-1.1l.1-.9z",
    style: {
      fill: "rgb(131, 197, 249)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "50px 50px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f47e5f",
    d: "M88.9 52.4C88 61.1 84.5 69.6 78.5 76c-3 3.2-6.4 5.9-10.2 8.1-3.8 2.1-8 3.5-12.3 4.3-8.6 1.6-17.7.1-25.4-3.9-3.9-2-7.4-4.7-10.4-7.8-3-3.2-5.5-6.8-7.4-10.7 2.4 3.7 5.3 7 8.6 9.6 3.3 2.6 6.9 4.7 10.7 6 3.8 1.3 7.7 2 11.6 2.1 1 0 1.9 0 2.9-.1l2.8-.3c1.9-.4 3.7-.7 5.4-1.4 3.5-1.2 6.7-2.9 9.5-5 2.8-2.2 5.1-4.7 6.9-7.5 1.8-2.8 3.1-5.8 3.8-8.8.7-3.1.9-6.1.7-9.1-.3-3.7 2.5-6.9 6.1-7.2 3.7-.3 6.9 2.5 7.2 6.1v1.1l-.1.9z",
    style: {
      fill: "rgb(79, 95, 225)"
    }
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "spin-b48b75b7-efa1-4baa-8473-555f7a3961d9",
    "data-anikit": ""
  }, "@keyframes spin-b48b75b7-efa1-4baa-8473-555f7a3961d9\n{\n  0% {\n    animation-timing-function: cubic-bezier(0.5856,0.0703,0.4143,0.9297);\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.49dc06d1800423389dfe9a5383913b3c.svg";
export { ForwardRef as ReactComponent };